import { MINUTES_IN_A_HOUR } from '../../constants/constants';

export const columns = ({ t }) => [
  {
    title: t('Name'),
    name: 'name'
  },
  {
    title: t('SCAC'),
    name: 'scac'
  },
  {
    title: t('Min. Lead Time'),
    name: 'leadTimeWindow'
  },
  {
    title: t('Rating Phone #'),
    name: 'ratingPhoneNumber'
  },
  {
    title: t('Dispatch Phone #'),
    name: 'dispatchPhoneNumber'
  },
  {
    title: t('Customer Service Phone #'),
    name: 'customerServicePhoneNumber'
  },
  {
    title: t('Insurance Policy #'),
    name: 'insurancePolicyNumber'
  },
  {
    title: t('Status'),
    name: 'status'
  }
];

export const mockedRows = [];

export const formatData = (items, t) =>
  items.map(item => ({
    status: item.active ? t('Active') : t('Inactive'),
    rowVersion: String(item.rowVersion),
    isNew: false,
    leadTimeWindow: item.leadTimeWindowMinutes / MINUTES_IN_A_HOUR,
    ...item
  }));

export default {
  columns,
  mockedRows,
  formatData
};
